/**
 * Контекст клиента для панели оператора (отдельный модуль — обход бага Turbopack
 * с именованным экспортом из большого `chat.ts`).
 */
import { apiClient } from '@/lib/api/client';

const API_BASE = process.env.NEXT_PUBLIC_API_URL || '';

export interface VisitorSubscriber {
  subscriber_id: string;
  full_name: string;
  phone?: string;
  email?: string;
  url?: string;
  passport_number?: string;
}

export interface VisitorFelixCustomer {
  id: string;
  name?: string;
  phone?: string;
  email?: string;
  customer_type?: string;
  web_url?: string;
}

export interface VisitorContext {
  phone?: string;
  subscriber?: VisitorSubscriber;
  felix_customers?: VisitorFelixCustomer[];
  felix_search_error?: string;
  subscriber_lookup_error?: string;
}

function authHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Client-ID': apiClient.clientId,
  };
  const token = apiClient.getSessionToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

async function parseResponse<T>(res: Response, fallback: string): Promise<T> {
  const json = await res.json().catch(() => ({}));
  if (!res.ok || (json?.status?.code && json.status.code >= 400)) {
    throw new Error(json?.status?.message || fallback);
  }
  return json.data as T;
}

export async function fetchVisitorContext(conversationId: string): Promise<VisitorContext> {
  const res = await fetch(`${API_BASE}/api/v1/chat/conversations/${conversationId}/visitor-context`, {
    headers: authHeaders(),
    credentials: 'include',
  });
  return parseResponse<VisitorContext>(res, 'Не удалось получить данные клиента');
}
